<template>
  <div class="entity-list">
    <template v-if="value.length">
      <span class="entity-list__label">{{ context.nonEmptyText }}</span>
      <button
        type="button"
        class="entity-list__add-btn-compact"
        @click="() => handleAdd()"
      >
        <app-icon name="plus" />
      </button>
    </template>
    <template v-else>
      <span class="entity-list__label">{{ context.emptyText }}</span>
      <button
        type="button"
        class="entity-list__add-btn"
        @click="() => handleAdd()"
      >
        <app-icon name="plus" />
        {{ context.addBtnText }}
      </button>
    </template>
  </div>
  <entity-list-items
    :context="context"
    :value="value"
    :on-edit="handleEdit"
    :on-delete="handleDelete"
  />
</template>

<script setup>
import { computed } from 'vue';
import EntityListItems from '@/components/form/entity-list/EntityListItems.vue';

const props = defineProps({
  context: Object,
});

const value = computed({
  get: () => props.context._value || [],
  set: (newValue) => {
    props.context.node.input(newValue);
  },
});

const handleAdd = () => {
  document.activeElement.blur();
  props.context.node.props.onAdd();
};

const handleEdit = (val) => {
  props.context.node.props.onEdit(val);
};

const handleDelete = (idx) => {
  const newValue = [...value.value];
  newValue.splice(idx, 1);
  props.context.node.input(newValue);
};
</script>

<style>
@reference '@/assets/main.css';

.entity-list {
  @apply w-full flex justify-between items-center h-14;
}

.entity-list__label {
  @apply text-sm text-gray-600;
}

.entity-list__add-btn {
  @apply btn btn-link p-0 no-underline border-0 outline-none!;
}

.entity-list__add-btn-compact {
  @apply btn text-brand-700 btn-square btn-ghost btn-sm;
}
</style>
